import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography, Breadcrumbs } from '@material-ui/core';
import { getLastValue } from '../generics/utils';
const Separator = (_jsx(Box, { component: "span", sx: {
        width: 4,
        height: 4,
        borderRadius: '50%',
        bgcolor: 'text.disabled',
    } }, void 0));
function LinkItem({ link }) {
    const { href, name, icon } = link;
    return (_jsxs(Link, Object.assign({ variant: "body2", component: RouterLink, to: href || '#', sx: {
            lineHeight: 2,
            display: 'flex',
            alignItems: 'center',
            color: 'text.primary',
            '& > div': { display: 'inherit' },
        } }, { children: [icon && (_jsx(Box, Object.assign({ sx: {
                    mr: 1,
                    '& svg': { width: 20, height: 20 },
                } }, { children: icon }), void 0)), name] }), name));
}
export function MBreadcrumbs({ links, activeLast = false, ...other }) {
    const currentLink = getLastValue(links)?.name;
    const listDefault = links.map((link) => _jsx(LinkItem, { link: link }, link.name));
    const listActiveLast = links.map((link) => (_jsx("div", { children: link.name !== currentLink ? (_jsx(LinkItem, { link: link }, void 0)) : (_jsx(Typography, Object.assign({ variant: "body2", sx: {
                maxWidth: 260,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                color: 'text.disabled',
                textOverflow: 'ellipsis',
            } }, { children: currentLink }), void 0)) }, link.name)));
    return (_jsx(Breadcrumbs, Object.assign({ separator: Separator }, other, { children: activeLast ? listDefault : listActiveLast }), void 0));
}
//# sourceMappingURL=MBreadcrumbs.js.map